import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { flush } from './profilerAggregator';

const FLUSH_INTERVAL_MS = 30_000;
const VISIBILITY_FLUSH_DEBOUNCE_MS = 1_000;
const EVENT_NAME = 'MV:ReactProfilerSummary';

let intervalId: ReturnType<typeof setInterval> | null = null;
let lastFlushAt = 0;

const scheduleFlushInterval = (): void => {
    intervalId = setInterval(sendEntries, FLUSH_INTERVAL_MS);
};

const sendEntries = (): void => {
    lastFlushAt = Date.now();

    const entries = flush();
    const route = window.location.pathname;

    entries.forEach((entry) => {
        logNewRelicPageAction(EVENT_NAME, {
            ...entry,
            route
        });
    });
};

const handleVisibilityChange = (): void => {
    if (document.visibilityState !== 'hidden') return;

    if (Date.now() - lastFlushAt < VISIBILITY_FLUSH_DEBOUNCE_MS) return;

    sendEntries();

    if (intervalId !== null) {
        clearInterval(intervalId);
        scheduleFlushInterval();
    }
};

export const startProfilerTelemetry = (): void => {
    if (intervalId !== null) return; // already started

    scheduleFlushInterval();
    document.addEventListener('visibilitychange', handleVisibilityChange);
};

export const stopProfilerTelemetry = (): void => {
    if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
    }
    lastFlushAt = 0;
    document.removeEventListener('visibilitychange', handleVisibilityChange);
};
